// @flow

import React, { Fragment } from 'react'
import styled from 'styled-components'
import OptimizedImage from 'components/atoms/OptimizedImage'
import { imageURLWithTransform } from 'frontend_core/dist/helpers/format'
import { mediaMax } from 'components/styles/_media'
import Colors from 'components/styles/colors'

const Thumbnail = styled.div`
  img {
    width: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    right: 0;
    margin: auto;
    vertical-align: bottom;
    transform: translate(-50%, -50%);
  }
`

const Thumbnail1 = Thumbnail.extend`
  position: relative;
  height: 354px;
  overflow: hidden;
  img {
    position: absolute;
    height: 100%;
    width: auto;
  }
`

const Thumbnail2 = Thumbnail.extend`
  width: 100%;
  height: 173px;
  position: relative;
  overflow: hidden;
`

const Thumbnail3 = Thumbnail.extend`
  overflow: hidden;
  height: 200px;
  width: auto;
  position: relative;
  ${mediaMax.desktop`
    height: 180px;
  `};
`

const PhotoViewMore = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 200px;
  width: 100%;
  text-align: center;
  background: rgba(0, 0, 0, 0.2);
  color: ${Colors.white};
  font-size: 16px;
  font-weight: bold;
  &:hover {
    background: transparent;
  }
  ${mediaMax.desktopLg`
    height: 100%;
  `} ${mediaMax.desktop`
    height: 200px;
  `};
`

const Icon = styled.i`
  display: block;
  margin-bottom: 8px;
  font-size: 30px;
`

const ViewMoreText = styled.div`
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translateY(-50%);
`

const RowChangedBox = styled.div`
  margin-left: ${Math.ceil(8 / -2)}px;
  margin-right: ${Math.floor(8 / -2)}px;
  > div {
    padding-right: 4px;
    padding-left: 4px;
    margin-bottom: 8px;
  }
  img {
    vertical-align: bottom;
  }
  &:after {
    content: '';
    clear: both;
    display: block;
  }
`

type PropTypes = {
  photos: Array<{
    url: string,
    description: string,
  }>,
  onClickPhoto: Function,
}

export default (props: PropTypes) => {
  const images = (props.photos || []).map((photo, i) => {
    const image = photo.url
      ? imageURLWithTransform(photo.url, {
          width: 688,
          height: 688,
          crop: 'fill',
        })
      : photo.url
    switch (i) {
      case 0:
        return (
          <Thumbnail1>
            <a href="#" target="_blank" onClick={e => props.onClickPhoto(e, 0)}>
              <OptimizedImage
                src={image}
                alt={photo.description}
                className="w100pa is-hover"
              />
            </a>
          </Thumbnail1>
        )
      case 1:
        return (
          <Thumbnail2 className="mb8">
            <a href="#" target="_blank" onClick={e => props.onClickPhoto(e, 1)}>
              <OptimizedImage
                src={image}
                alt={photo.description}
                className="w100pa is-hover"
              />
            </a>
          </Thumbnail2>
        )
      case 2:
        return (
          <Thumbnail2>
            <a href="#" target="_blank" onClick={e => props.onClickPhoto(e, 2)}>
              <OptimizedImage
                src={image}
                alt={photo.description}
                className="w100pa is-hover"
              />
            </a>
          </Thumbnail2>
        )
      case 3:
        return (
          <div className="col-xs-12 col-md-4">
            <Thumbnail3>
              <a
                href="#"
                target="_blank"
                onClick={e => props.onClickPhoto(e, 3)}
              >
                <OptimizedImage
                  src={image}
                  alt={photo.description}
                  className="w100pa is-hover"
                />
              </a>
            </Thumbnail3>
          </div>
        )
      case 4:
        return (
          <div className="col-xs-12 col-md-4">
            <Thumbnail3>
              <a
                href="#"
                target="_blank"
                onClick={e => props.onClickPhoto(e, 4)}
              >
                <OptimizedImage
                  src={image}
                  alt={photo.description}
                  className="w100pa is-hover"
                />
              </a>
            </Thumbnail3>
          </div>
        )
      case 5:
        return (
          <div key={`detail_photo_${i}`} className="col-xs-12 col-md-4">
            <Thumbnail3>
              <a
                href="#"
                target="_blank"
                onClick={e => props.onClickPhoto(e, 0)}
              >
                <OptimizedImage
                  src={image}
                  alt={photo.description}
                  className="w100pa is-hover"
                />
                <PhotoViewMore>
                  <ViewMoreText>
                    <Icon className="fa fa-camera" />
                    {i18n.t('page.room.viewAllPhoto')}
                  </ViewMoreText>
                </PhotoViewMore>
              </a>
            </Thumbnail3>
          </div>
        )
      default:
        return null
    }
  })

  return (
    <Fragment>
      <RowChangedBox className="row row-change__4 sm-hide">
        <div className="col-xs-12 col-sm-6 space-main__photo-1">
          {images[0]}
        </div>
        <div className="col-xs-12 col-md-6 sm-hide">
          {images[1]}
          {images[2]}
        </div>
      </RowChangedBox>
      <RowChangedBox>
        {images[3]}
        {images[4]}
        {images.length > 5 ? images[5] : null}
      </RowChangedBox>
    </Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/components/molecules/room/DetailPhotos/index.jsx